import type { ListingsAPIResponseTextFacetValue } from '@noths/polaris-client-listings-api';

import type { Facet, FacetOption } from 'src/redux/productsQuery/types/Facet';

export const getUpdatedOptionsForTextFacet = (
  storeFacet: Facet,
  listingsFacetValues: ListingsAPIResponseTextFacetValue[],
): FacetOption[] => {
  const listingsValuesPresentInStore: ListingsAPIResponseTextFacetValue[] = [];
  const listingsValuesNotInStore: ListingsAPIResponseTextFacetValue[] = [];

  listingsFacetValues.forEach((listingValue) => {
    const storeOption = storeFacet.options.find(
      (storeOption) => storeOption.value === listingValue.value,
    );

    if (storeOption) {
      listingsValuesPresentInStore.push(listingValue);
    } else {
      listingsValuesNotInStore.push(listingValue);
    }
  });

  const updatedStoreOptions = storeFacet.options.map((storeOption) => {
    const listingValue = listingsValuesPresentInStore.find(
      (value) => value.value === storeOption.value,
    );

    return {
      ...storeOption,
      active: storeOption.active || false,
      count: listingValue ? parseInt(listingValue.count, 10) : 0,
    };
  });

  if (!storeFacet.disallowNewValues) {
    listingsValuesNotInStore.forEach((listingValue) => {
      updatedStoreOptions.push({
        active: false,
        count: parseInt(listingValue.count, 10),
        title: listingValue.value,
        value: listingValue.value,
      });
    });
  }

  return updatedStoreOptions;
};
